import React, { FC, useState } from 'react'
import { WarningButton, WarningContainer, WarningDetails, WarningMessage } from './styles'
import * as FormStyles from '../../../knowledgeBase/UploadForm/UploadForm.style'
import LoaderSmall from 'uiKit/loaders/loaderSmall'
import { unknownQuestionService } from '../../../../api/unknownQuestions'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { QuestionImportDetailsDTO } from '../../../../api/types'
import WarningIcon from '@mui/icons-material/Warning'

export const QuestionUploadForm: FC<{ onImportComplete: () => void }> = ({ onImportComplete }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [importDetails, setImportDetails] = useState<QuestionImportDetailsDTO | null>(null)

  const handleUpload = async (event: { target: { files: any[] } }) => {
    setIsLoading(true)
    setImportDetails(null)

    const file = event.target.files[0]
    const formData = new FormData()
    formData.append('file', file)
    try {
      const response = await unknownQuestionService.uploadQuestionsFromFile(formData)
      setImportDetails(response)

      if (response?.invalidQuestions?.length === 0) {
        onImportComplete()
      }
    } catch (error) {
      console.error('Upload failed:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleExport = () => {
    if (importDetails?.invalidQuestions?.length === 0) return

    const worksheet = XLSX.utils.json_to_sheet(importDetails.invalidQuestions)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Invalid Questions')

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    saveAs(data, 'invalid-questions.xlsx')
  }

  return (
    <>
      {isLoading ? (
        <LoaderSmall showLoader />
      ) : (
        <FormStyles.UploadForm>
          <FormStyles.Button htmlFor="upload">Upload file</FormStyles.Button>
          <FormStyles.File id="upload" type="file" accept=".xlsx" onChange={handleUpload} />
          <FormStyles.Title>Files should be XLSX</FormStyles.Title>
        </FormStyles.UploadForm>
      )}

      {importDetails?.invalidQuestions?.length > 0 && (
        <WarningContainer>
          <WarningIcon style={{ color: '#ffc107', fontSize: '30px' }} />
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
            <WarningMessage>
              <strong>{importDetails.invalidImportedCount}</strong> out of
              <strong> {importDetails.validImportedCount + importDetails.invalidImportedCount} </strong>
              questions were not imported due to validation issues.
            </WarningMessage>
          </div>

          <WarningDetails>
            Download the file, review the errors, and fix them
            <br />
            before re-uploading.
          </WarningDetails>

          <WarningButton onClick={handleExport}>Download</WarningButton>
        </WarningContainer>
      )}
    </>
  )
}
